import { render, staticRenderFns } from "./lazy-load.vue?vue&type=template&id=3a9d141a&"
import script from "./lazy-load.vue?vue&type=script&lang=js&"
export * from "./lazy-load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports